import { useState, useContext } from "react";
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";
import { useModal } from '../useModal';
import { UserContext } from "../../context/provider/UserProvider";

const urlActividades = process.env.REACT_APP_XPROJECT_API + "/Activity";
export const useActividades = () => {
    const { stateUser } = useContext(UserContext);
    const fecha = new Date();
    const hora = new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    const [ fechaInicioActividad, setFechaInicioActividad ] = useState(fecha);
    const [ fechaFinActividad, setFechaFinActividad ] = useState(fecha);
    const [ horaInicioActividad, setHoraInicioActividad ] = useState(hora)
    const [ horaFinActividad, setHoraFinActividad ] = useState(hora)
    const [ fechaEstadoActividad, setFechaEstadoActividad ] = useState(fecha);
    const [ horaEstadoActividad, setHoraEstadoActividad ] = useState(hora);

    const actividadDefault = {
        codTicketActividad: 0,
        codTicketEntregable: 0,
        codUsuarioResponsable: 0,
        nomActividad: "",
        fechaInicioProgramadoActividad: '',
        horaInicioProgramadoActividad: '',
        fechaFinProgramadoActividad: '',
        horaFinProgramadoActividad: '',
        codTicketActividadPredecesor: '',
        codPrioridad: 3,
        codComplejidad: 3,
    }

    const inicioFinActividadDefault = {
        codTicket: 0,
        codTicketActividad: 0,
        codEstadoTicketActividad: '',
        fecha: '',
        hora: '',
        nomActividad: ''
    }

    const pausarActividadDefault = {
        codTicketActividad: 0,
        codTicketActividadPausaTipo: 0
    }
    const [ actividades, setActividades ] = useState([]);
    const [ actividad, setActividad ] = useState(actividadDefault);
    const [ inicioFinActividad, setInicioFinActividad ] = useState(inicioFinActividadDefault);
    const [ actividadesUsuario, setActividadesUsuario ] = useState([]);
    const [ actividadesPorTicket, setActividadesPorTicket ] = useState([]);
    const [ isOpenModalActividad, openModalActividad, closeModalActividad ] = useModal()
    const [ isOpenModalValidarEstado, openModalValidarEstado, closeModalValidarEstado ] = useModal();
    const [ tipoPausa, setTipoPausa ] = useState([])
    const [ actividadPausada, setActividadPausada ] = useState(pausarActividadDefault);
    const [ loading, setLoading] = useState(false);

    const listarActividad = async (codTicketEntregable) => {
        try
        {
            const response = await Fetch({
                url: urlActividades + '?' + new URLSearchParams({
                    codTicketEntregable: codTicketEntregable
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setActividades(response.isValid ? response.content : []);
        }
        catch(e)
        {
            setActividades([]);
            console.log('Error al listar actividades: ',e)
            notify('Ocurrió un error en el servicio','error');
        }
    } 

    const listarActividadesPorUsuario = async (fechaInicio,fechaFin,codUsuario, codEstado) => {
        try{
            const response = await Fetch({
                url: urlActividades + '/userDateRange?' + new URLSearchParams({
                    CodUsuarioAccion: codUsuario,
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin,
                    CodEstado: codEstado
                })
            })
            setActividadesUsuario(response.isValid ? response.content : [])
            setLoading(false)
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar actividades: ',e)
            setLoading(false)
        }

    }

    const listarActividadesPorTicket = async (codTicket) => {
        const response = await Fetch({
            url: urlActividades + '/ticket?' + new URLSearchParams({
                CodTicket: codTicket,
            })
        })
        
        !response.isValid && notify(response.exceptions[0].description, 'error')
        if(response.isValid){
            setActividadesPorTicket(response.content)
        }
    }

    const obtenerActividadDetalle = async (codTicketActividad) => {
        try{

            if(codTicketActividad){
                const response = await Fetch({
                    url: urlActividades + '/detail?' + new URLSearchParams({
                        CodTicketActividad: codTicketActividad
                    })
                })
        
                if(response.isValid){
                    response.content[0].codTicketActividad = codTicketActividad;
                    // response.content[0].codTicketActividadPredecesor = 0;
                    // response.content[0].codPrioridad = 3;
                    // response.content[0].codComplejidad = 3;
                    setActividad(response.content[0]);
                }
            }
            else{
                setActividad(actividadDefault);
            }
        }
        catch(error){
            setActividad(actividadDefault);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar detalle : ',error)
        }
    }
    
    const obtenerCambiarEstadoActividad = () => {
        setFechaEstadoActividad(new Date())
        setHoraEstadoActividad(new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}))
        // openModalValidarEstado()
    } 

    const guardarEditarActividad = async () => {
        try{
            const esGuardar = actividad.codTicketActividad === 0 || actividad.codTicketActividad === undefined ? true : false;
            const response = await Fetch({
                url: urlActividades,
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    ...( esGuardar ?
                        {
                            codTicketEntregable: actividad.codTicketEntregable,
                        }
                        :
                        {
                            codTicketActividad: actividad.codTicketActividad,
                        }
                    ),
                    codUsuarioAccion: stateUser.codUsuario,
                    nomActividad: actividad.nomActividad,
                    codUsuarioResponsable: actividad.codUsuarioResponsable,
                    fechaInicioProgramado: actividad.fechaInicioProgramadoActividad + ' ' + actividad.horaInicioProgramadoActividad ,
                    fechaFinProgramado: actividad.fechaFinProgramadoActividad + ' ' + actividad.horaFinProgramadoActividad,
                    codTicketActividadConcatenado: actividad.codTicketActividadPredecesor,
                    codPrioridad: actividad.codPrioridad,
                    codComplejidad: actividad.codComplejidad,
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(error){
            notify('Ocurrio un error en el servicio', 'error');
            console.log('Error al guardar: ',error)
            return false;
        }
    }

    const cambiarEstadoActividad = async () => {
        try{
            const response = await Fetch({
                url: urlActividades + '/start',
                method: 'POST',
                body:JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodTicketActividad: inicioFinActividad.codTicketActividad,
                    FechaAccion: inicioFinActividad.fecha + ' ' + inicioFinActividad.hora
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid;
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al registrar cambio de estado: ', error);
            return false
        }
    }

    const pausarActividadConMotivo= async () => {
        const response = await Fetch({
            url: urlActividades + '/pause/start',
            method: 'PUT',
            body:JSON.stringify({
                CodUsuarioAccion: stateUser.codUsuario,
                CodTicketActividad: actividadPausada.codTicketActividad,
                codTicketActividadPausaTipo: actividadPausada.codTicketActividadPausaTipo,
            })
        })
        notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
        return response.isValid
    }

    const finalizarActividadPausada = async (codActividadPausa) => {
        const response = await Fetch({
            url: urlActividades + '/pause/final',
            method: 'PUT',
            body:JSON.stringify({
                CodUsuarioAccion: stateUser.codUsuario,
                CodTicketActividadPausa: codActividadPausa,
            })
        })
        notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
        return response.isValid
    }

    const listarTipoPausa = async () => {
        try{
            const response = await Fetch({
                url: urlActividades + '/pause/types',
                method: 'GET',
            });
            
            if(response.isValid){
                setTipoPausa(response.content);
            }
            else{
                setTipoPausa([]);
                notify(response.exceptions[0].description, 'error');
            }
        }
        catch(error){
            setTipoPausa([]);
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar ',error);
        }
        
    }

    const editarValorActividad = (key, value) => {
        setActividad(actividad => {
            return {
                ...actividad,
                [key]: value
            }
        });
    }

    const eliminarActividad = async () => {
        try{
            const response = await Fetch({
                url: urlActividades,
                method: 'DELETE',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codTicketActividad: actividad.codTicketActividad
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description , response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al eliminar la actividad: ',e)
            return false;
        }
    }

    const editarValorActividadPausa = async (key, value) => {
        setActividadPausada(actividadPausa => {
            return {
                ...actividadPausa,
                [key]: value
            }
        });
    }

    const editarValorInicioFinActividad = (key, value) => {
        setInicioFinActividad(inicioFin => {
            return {
                ...inicioFin,
                [key] : value
            }
        })
    }

    const regularizarActividad = async (codTicketActividad) => {
        try{
            const response = await Fetch({
                url : urlActividades + '/regularize',
                method: 'POST',
                body:JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodTicketActividad: codTicketActividad,
                })
            });

            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid;
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al regularizar actividad: ',error)
        }
    }


    return{
        actividad,
        actividades,
        listarActividad,
        editarValorActividad,
        guardarEditarActividad,
        isOpenModalActividad,
        openModalActividad,
        closeModalActividad,
        obtenerActividadDetalle,
        actividadDefault,
        setActividad,
        listarActividadesPorUsuario,
        actividadesUsuario,
        cambiarEstadoActividad,
        isOpenModalValidarEstado,
        openModalValidarEstado,
        closeModalValidarEstado,
        listarActividadesPorTicket,
        actividadesPorTicket,
        obtenerCambiarEstadoActividad,
        fechaInicioActividad,
        setFechaInicioActividad,
        fechaFinActividad,
        setFechaFinActividad,
        horaInicioActividad,
        setHoraInicioActividad,
        horaFinActividad,
        setHoraFinActividad,
        eliminarActividad,
        fechaEstadoActividad,
        setFechaEstadoActividad,
        horaEstadoActividad,
        setHoraEstadoActividad,
        tipoPausa,
        listarTipoPausa,
        pausarActividadConMotivo,
        finalizarActividadPausada,
        editarValorActividadPausa,
        editarValorInicioFinActividad,
        inicioFinActividad,
        loading,
        setLoading,
        regularizarActividad,
    }
 

}